import ISSUE_NAME from '@constant/issue-name';
import * as Sentry from '@sentry/browser';
import { Severity } from '@sentry/browser';
import { ValueOf } from './type';

/**
 * 初始化 sentry
 */
export const initSentry = () => {
  if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({
      // 本地开发环境 sentry 不启用
      enabled: process.env.REACT_APP_ENV !== 'DEV' && process.env.NODE_ENV === 'production',
      dsn: process.env.REACT_APP_SENTRY_DSN,
      // @ts-expect-error
      release: `voov-${APP_VERSION}`,
    });
  }
};

/**
 *
 * 上报 Message
 * @export
 * @param {string} issueName 没有变量，应该是中文常量
 * @param {string} biz 模块分类： FIXME: 这个需要传递吗？
 * @param {Record<string, any>} context 附加数据，应该是可以 json 化的 plain object
 */
export function captureMessage(issueName: ValueOf<typeof ISSUE_NAME>, biz: string, context: Record<string, any>) {
  Sentry.captureMessage(issueName, {
    tags: {
      biz,
    },
    extra: { ...context },
  });
}

/**
 * 上报 Warning
 *
 * @export
 * @param {string} issueName 没有变量，应该是中文常量
 * @param {string} biz 模块分类： FIXME: 这个需要传递吗？
 * @param {Record<string, any>} context 附加数据，应该是可以 json 化的 plain object
 */
export function captureWarning(issueName: ValueOf<typeof ISSUE_NAME>, biz: string, context: Record<string, any>) {
  Sentry.captureException(issueName, {
    level: Severity.Warning,
    tags: {
      biz,
    },
    extra: { ...context },
  });
}

/**
 * 上报错误
 *
 * @export
 * @param {string} issueName 没有变量，应该是中文常量
 * @param {string} biz 模块分类： FIXME: 这个需要传递吗？需要，但是我看旧版本传的是一个对象
 * @param {Record<string, any>} context 附加数据，应该是可以 json 化的 plain object
 */
export function captureException(issueName: ValueOf<typeof ISSUE_NAME>, biz: string, context: Record<string, any>) {
  Sentry.captureException(issueName, {
    tags: {
      biz,
    },
    extra: { ...context },
  });
}

/**
 * @param {string} key String of extra
 * @param {Record<string, any>} context 附加数据，应该是可以 json 化的 plain object
 */
export function setExtra(key: string, context: Record<string, any>) {
  Sentry.setExtra(key, context);
}
